import React from 'react'
import { withNamespaces } from 'react-i18next'
import { Link } from 'react-router-dom'

export default withNamespaces()(({ children, t }) => (
  <React.Fragment>
    <div>{children}</div>

    <div>
      <Link to="/">{t('common:goToMain')}</Link>
    </div>
  </React.Fragment>
))
